import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import YourInformation from './components/YourInformation'
import Contact from './components/Contact'
import { PAGE_BREAKPOINTS } from 'parameters/index'
import { useKeycloak } from 'services/Authentication/context/useKeycloak'
import { getUserClient } from 'services/FionaAPI/clients'
import Logger from 'services/Logger'
import { UserWithRelations } from 'generated/api'

export const AccountSettings: React.FC<React.PropsWithChildren<unknown>> = (): JSX.Element => {
	const [profile, setProfile] = useState<UserWithRelations>({ id: '' })
	const [keycloak, init] = useKeycloak()

	useEffect(() => {
		if (init) {
			async function getProfileInfo(): Promise<void> {
				try {
					let user
					const client = getUserClient()
					if (keycloak.subject) {
						user = await client.getUser({ id: keycloak.subject })
						setProfile(user)
					}
				} catch (err) {
					Logger.error(err)
				}
			}
			getProfileInfo()
		}
	}, [init, keycloak])

	return (
		<div>
			<h2 style={{ marginBottom: '32px' }}>Account</h2>
			<Flexbox>
				<MediumBox>
					<YourInformation profile={profile} setProfile={setProfile} />
				</MediumBox>
				{/* <SmallBox className="linkAccounts">
					<LinkAccounts profile={profile} />
				</SmallBox>
				<SmallBox className="communicationPreferences">
					<CommunicationPreferences />
				</SmallBox> */}
				<SmallBox className="contact">
					<Contact />
				</SmallBox>
			</Flexbox>
			<Flexbox>
				{/* <WideBox>
					<DataPrivacy />
				</WideBox> */}
			</Flexbox>
		</div>
	)
}

const Flexbox = styled.div`
	display: flex;

	@media only screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		flex-wrap: wrap;
	}
`

const SmallBox = styled.div`
	width: 24%;
	margin-left: 2%;
	> div {
		height: 100%;
	}
	margin-bottom: 24px;
	@media only screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		&.linkAccounts {
			width: 35%;
		}

		&.communicationPreferences {
			width: 100%;
			margin-left: 0;
		}

		&.contact {
			width: 35%;
		}
	}

	@media only screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		&.linkAccounts {
			width: 49%;
			margin-left: 0;
		}

		&.contact {
			width: 100%;
			margin-left: 0;
		}

		&.communicationPreferences {
			width: 49%;
			margin-left: 2%;
		}
	}

	@media only screen and (${PAGE_BREAKPOINTS.MOBILE}) {
		&.linkAccounts,
		&.contact,
		&.communicationPreferences {
			width: 100%;
			margin-left: 0;
		}
	}
`

const MediumBox = styled.div`
	display: flex;
	flex-direction: column;
	width: 48%;
	justify-content: space-between;
	margin-bottom: 24px;
	@media only screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		width: 63%;
	}

	@media only screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		width: 100%;
	}

	@media only screen and (${PAGE_BREAKPOINTS.MOBILE}) {
		width: 100%;
	}
`

// const WideBox = styled.div`
// 	width: 74%;
// 	margin-bottom: 24px;
// 	@media only screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
// 		width: 63%;
// 	}

// 	@media only screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
// 		width: 49%;
// 	}

// 	@media only screen and (${PAGE_BREAKPOINTS.MOBILE}) {
// 		width: 100%;
// 	}
// `
